import * as React from 'react';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Switch from '@mui/material/Switch';
import { Box, TextField, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import InvertidoIcon from '@mui/icons-material/Paid';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import AddIcon from '@mui/icons-material/AddCircleOutline';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
  },
}));


export default function Tabla(props) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(9999);



  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };



  const selectRegistro = (registro) => {
    props.setRegistroActual(registro)
  }

  const handleChangeInvertir = (id) => {
    props.changeInvertir(id)
  }

  const handleEditInvertir = (id) => {
    props.editInvertir(id)
  }
//              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
  return (
    <Paper sx={{ width: '100%', overflow: 'hidden',  }}  elevation={10}>
      {/* Barra de encabezado */}
      <Box sx={{
        background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
        py: 1.5,
        px: 2,
        borderBottom: '3px solid #d4af37'
      }}>
        <Typography
          variant="subtitle1"
          sx={{
            color: 'white',
            fontWeight: 600,
            textAlign: 'center',
            letterSpacing: 0.5
          }}
        >
          Inversiones Disponibles
        </Typography>
      </Box>
      <TableContainer >
        <Table stickyHeader aria-label="sticky table" size="small">
          <TableHead>
            <TableRow>
              {props.columnas.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                  sx={{
                    background: 'linear-gradient(90deg, #1e3a5f 0%, #2c5282 100%)',
                    color: 'white',
                    fontWeight: 600,
                    fontSize: '0.8rem',
                    py: 1.25,
                    borderBottom: '2px solid #d4af37'
                  }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {props.rows
              .map((row) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.id} onClick={() => selectRegistro(row)}>
                    {props.columnas.map((column) => {
                      let value = row[column.id];
                      if (column.id=="id"){value=''}
                      if (column.id == "balance" || column.id == "disponible") { value = parseFloat(value).toLocaleString('en-US', { minimumFractionDigits: 2 }) }
                      let resultado = null;
                      if (column.id == "invertir") {
                        resultado = <TableCell key={column.id}><Switch disabled={row.invertido > 0} checked={props.rows[row.indice].invertir} onChange={() => { handleChangeInvertir(row.id) }} inputProps={{ 'aria-label': 'controlled' }} /></TableCell>;
                      } else if (column.id == "invertido") {
                        let invertido = parseFloat(row.invertido)
                        if (invertido > 0) {
                          resultado = <TableCell key={column.id}><Tooltip title={"Usted ya tiene invertido: " + parseFloat(row.invertido).toLocaleString('en-US', { minimumFractionDigits: 2 })}>
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
                              <InvertidoIcon style={{ marginTop: "8px" }} />
                              {
                                ( parseInt(row.reenganche) == 0 ? <div></div> : <IconButton onClick={() => { props.addInvertir(row.id) }}>
                                  <AddIcon />
                                </IconButton>)
                              }


                            </div>

                          </Tooltip></TableCell>
                        } else {
                          resultado = <TableCell key={column.id}></TableCell>
                        }
                      } else if (column.id == "monto_invertir") {
                        if (row.monto_invertir > 0) {
                          resultado = <TableCell key={column.id}>
                            <Box>
                              {value.toLocaleString('en-US', { minimumFractionDigits: 2 })}
                              <IconButton aria-label="edit"
                                onClick={() => { handleEditInvertir(row.id) }}
                                size='small'
                              >
                                <EditIcon />
                              </IconButton>
                            </Box>
                          </TableCell>
                        } else {
                          resultado = <TableCell key={column.id}></TableCell>
                        }

                      } else {
                        resultado = <StyledTableCell key={column.id} align={column.align}>
                          {column.format && typeof value === 'number'
                            ? column.format(value)
                            : value}
                        </StyledTableCell>
                      }
                      return (
                        resultado
                      );
                    })}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
{/*       <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={props.rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      /> */}
    </Paper>
  );
}